import {Account} from './api/account.api';
import {IProjectEntity} from './Project';
import {IVendorListItemClassificationAssignmentEntity} from './VendorList';
export interface IAccountEntity extends Entities.BaseEntity {
  firstName: string;
  lastName: string;
  emailAddress: string;
  isEmailValidated: boolean;
  lastLoginDate: Date | null;
  isAdmin: boolean;
  role: RolesType;
  projectAssignments: IAccountPermissionsEntity[];
  userRoles: IUserRoleEntity[];
  getPublicDetails(): Account.GetAccountResponse;
  hasRole(role: RolesType[]): boolean;
}

export type RolesType = 'super' | 'admin' | 'project-admin' | 'readonly' | 'contractor';

export interface RolePermissions {
  create: boolean;
  read: boolean;
  list: boolean;
  update: boolean;
  delete: boolean;
  applicationModuleId: number;
  applicationModule: {id: number; name: string; description?: string;}
}

export interface IRoleEntity extends Entities.BaseEntity {
  name: string;
  description?: string;
  permissions: RolePermissions[];
  isSystem: boolean;
}

export interface IUserRoleEntity extends Entities.BaseEntity {
  accountId: number;
  roleId: number;
  role: IRoleEntity;
  assignedBy: number;
  assignedAt: Date;
}

export interface IAccountPermissionsEntity extends Entities.BaseEntity {
  account: IAccountEntity;
  accountId: number;
  project: IProjectEntity;
  projectId: number;
  level: RolesType;
}

export enum PermissionLevelEnum {
  Admin = 'admin',
  ProjectAdmin = 'project-admin',
  Contractor = 'contractor',
  ReadOnly = 'readonly'
}

export interface INotificationEntity extends Entities.BaseEntity {
  account: IAccountEntity;
  accountId?: number;
  projectId?: number;
  notificationId: string;
  type: EnumNotificationType;
  allAdmins: boolean;
  name?: string;
  data: string | null;
  message?: string | null;
  seenOn?: Date | null;
  linkTo?: string;
  redirectTo?: string | null;
  completedBy?: IAccountEntity;
  completedById?: number | null;
  completedOn?: Date | null;
  requiredFinish?: Date | null;
}

export enum EnumNotificationType {
  Info = 'info',
  Warning = 'warn',
  Error = 'error',
  Critical = 'critical',
  RemoveVendorRequest =  'Remove Vendor Request',
  CertifySubListRequest = 'Certify Sub List Request'
}
/**
 * List of Sub-Contractor Classifications
 */
export interface IClassificationEntity extends Entities.BaseEntity {
  name: string;
  vendorListItem: IVendorListItemClassificationAssignmentEntity;
}

export interface ICraftEntity extends Entities.BaseEntity {
  name: string;
  link?: string;
}

export interface ILicenseEntity extends Entities.BaseEntity {
  name: string;
  link?: string;
}

export interface IApplicationSettingsEntity {
  name: string;
  value: string;
  comment: string | undefined;
}

/**
 * Entity: table name
 */
export interface IAuditLogEntity extends Entities.BaseEntity {
  entity: string;
  actionType: string;
  account: IAccountEntity;
  accountId: number;
  description: string;
}

export interface IStatus extends Entities.BaseEntity {
  shortName: string;
  name: string;
  description: string;
}

export interface IAuthenticationEntity extends Omit<Entities.BaseEntity, 'id'> {
  id: string; // UUID
  accountId: number;
  account: IAccountEntity;
  path: string; // redirect path
  expires: Date;
  system: IApplicationSettingsEntity; // System where session is valid, references application settings
  systemId: string;
}

export interface ISessionEntity {
  sessionId: string; // UUID
  accountId: number;
  account: IAccountEntity;
  refresh: Date;
  created: Date;
  system: IApplicationSettingsEntity; // System where session is valid, references application settings
  systemId: string;
}

export namespace Entities {
  export interface BaseEntity {
    id: number;
    isActive: boolean;
    created: Date;
    createdBy?: number | null;
    updated: Date;
    updatedBy?: number | null;
    deleted: Date | null;
    deletedBy?: number | null;
  }
}
